import { valueSection } from '@/mocks/content';

export default function ValueSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            {valueSection.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[650px] mx-auto leading-relaxed">
            {valueSection.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {valueSection.features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-lg p-6 border border-background-200/70 hover:border-background-300 transition-colors"
            >
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}